import React from "react";
import {
  Sparkles, Scale, Banknote, Ruler, Leaf, Truck, Hammer, ShieldCheck, BadgeCheck, ScrollText,
} from "lucide-react";
import { categories } from "../../data/marketplaceData";

const iconMap = { Sparkles, Scale, Banknote, Ruler, Leaf, Truck, Hammer, ShieldCheck, BadgeCheck, ScrollText };

export const CategoryFilter = ({ active, onSelect }) => (
  <section className="rounded-2xl border border-slate-200 bg-white cf-shadow p-4" data-testid="category-filter">
    <div className="flex items-center gap-2 overflow-x-auto cf-scroll pb-1">
      {categories.map((c) => {
        const Icon = iconMap[c.icon] || Sparkles;
        const isActive = active === c.id;
        return (
          <button
            key={c.id}
            data-testid={`mkt-cat-${c.id}`}
            onClick={() => onSelect(c.id)}
            className={`shrink-0 inline-flex items-center gap-2 h-10 px-3.5 rounded-xl border text-[12.5px] font-medium transition-all ${
              isActive
                ? "bg-slate-900 border-slate-900 text-white shadow-[0_8px_20px_rgba(15,23,42,0.18)]"
                : "bg-white border-slate-200 text-slate-700 hover:border-slate-300"
            }`}
          >
            <Icon size={13} />
            {c.name}
            <span className={`text-[10.5px] font-semibold px-1.5 py-0.5 rounded ${isActive ? "bg-white/15 text-white" : "bg-slate-100 text-slate-500"}`}>
              {c.count}
            </span>
          </button>
        );
      })}
    </div>
  </section>
);
